import { Component, OnInit, Input } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { PerformanceRiskAnalysis } from 'src/app/models/analysis/performance-risk-analysis.model';
import { ComponentsAnalysis } from 'src/app/models/analysis/components-analysis.model';

import { TableUtil } from "src/app/utils";

@Component({
  selector: 'app-analytics-performance',
  templateUrl: './analytics-performance.component.html',
  styleUrls: ['./analytics-performance.component.scss']
})
export class AnalyticsPerformanceComponent implements OnInit {

  @Input() originalPRA: PerformanceRiskAnalysis;
  @Input() benchmarkPRA: PerformanceRiskAnalysis;
  @Input() investablePRA: PerformanceRiskAnalysis;
  @Input() protectedPRA: PerformanceRiskAnalysis;
  @Input() currentCA: ComponentsAnalysis;

  @Input() inceptionDate: Date;
  @Input() lastDate: Date;

  selectedAllTab: string = 'overview';
  selectedOverviewTab: string = 'all';
  selectedAbsoluteTab: string = 'Returns';
  selectedRelativeTab: string = 'Excess Returns';
  selectedComponentsTab: string = 'analytics';

  lastYears: number[];

  panelOpenState = false;

  constructor() { }

  ngOnInit(): void {
    const years = Object.keys(this.benchmarkPRA.yearly_returns).map((key) => (+key));
    const lastYear = Math.max(...years);
    this.lastYears = [...Array(5).keys()].map((i) => (lastYear-4+i));
  }

  onAllTabChange(event: MatTabChangeEvent) {
    switch (event.tab.textLabel) {
      case 'Overview':            this.selectedAllTab='overview'; break;
      case 'Absolute':            this.selectedAllTab='absolute'; break;
      case 'Relative':            this.selectedAllTab='relative'; break;
      case 'Components':          this.selectedAllTab='components'; break;
    }
  }

  onOverviewTabChange(event: MatTabChangeEvent) {
    switch (event.tab.textLabel) {
      case 'All since inception': this.selectedOverviewTab='all'; break;
      case 'Original':            this.selectedOverviewTab='original'; break;
      case 'Investable':          this.selectedOverviewTab='investable'; break;
      case 'Protected':           this.selectedOverviewTab='protected'; break;
    }
  }

  onAbsoluteTabChange(event: MatTabChangeEvent) {
    switch (event.tab.textLabel) {
      case 'Returns':               this.selectedAbsoluteTab='Returns'; break;
      case 'Volatility':            this.selectedAbsoluteTab='Volatility'; break;
      case 'Sharpe ratio':          this.selectedAbsoluteTab='Sharpe ratio'; break;
      case 'Max Drawdown':          this.selectedAbsoluteTab='Max Drawdown'; break;
      case 'Value at Risk':         this.selectedAbsoluteTab='Value at Risk'; break;
      case 'Calmar ratio':          this.selectedAbsoluteTab='Calmar ratio'; break;
      case 'Yearly Returns':        this.selectedAbsoluteTab='Yearly Returns'; break;
    }
  }

  onRelativeTabChange(event: MatTabChangeEvent) {
    switch (event.tab.textLabel) {
      case 'Excess Returns':         this.selectedRelativeTab='Excess Returns'; break;
      case 'Tracking Error':         this.selectedRelativeTab='Tracking Error'; break;
      case 'Information ratio':      this.selectedRelativeTab='Information ratio'; break;
      case 'Max Relative Drawdown':  this.selectedRelativeTab='Max Relative Drawdown'; break;
      case 'Market Exposure':        this.selectedRelativeTab='Market Exposure'; break;
    }
  }

  onComponentsTabChange(event: MatTabChangeEvent) {
    switch (event.tab.textLabel) {
      case 'Analytics':     this.selectedComponentsTab='analytics'; break;
      case 'Contributions': this.selectedComponentsTab='contribution'; break;
      case 'Rating':        this.selectedComponentsTab='rating'; break;
    }
  }

  exportTable(){
    TableUtil.exportToExcel("tableToExport");
  }

}
